import { notificationsMerge } from '@microsoft/portal-app/lib/Notifications/helpers/notificationsMerge';
import {
  INotification,
  NotificationSeverity,
  NotificationType
} from '@microsoft/portal-app/lib/Notifications/models/INotification';
import { getResponseValue, IODataValueResponse } from '@microsoft/portal-app/lib/odata-utils';
import { AnyPayload } from '@microsoft/portal-app/lib/redux/AnyPayload';
import moment from 'moment';
import { MiddlewareAPI } from 'redux';
import { ActionsObservable, Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import { map, switchMap } from 'rxjs/operators';
import { auth } from '../../../auth';
import { getSignOutApiUrl } from '../../../redux/modules/accountApis';
import { AccountActions } from '../../models/AccountActions';
import { IAccountAction } from '../../models/IAccountAction';
import { IAccountState, IRootAccountState } from '../../models/IAccountState';
import { accountRegistry as registry } from '../accountRegistry';

export const submitSignOutEpic: Epic<IAccountAction<AnyPayload>, IRootAccountState> = (
  action$: ActionsObservable<IAccountAction>,
  _store: MiddlewareAPI<IRootAccountState>,
  { ajax }: { ajax: AjaxCreationMethod }
): Observable<IAccountAction<AnyPayload>> => {
  return action$.ofType(AccountActions.submitSignOut).pipe(
    switchMap(() => {
      return ajax({
        method: 'POST',
        url: getSignOutApiUrl()
      }).pipe(
        map((payload: IODataValueResponse<boolean>) => {
          return {
            type: AccountActions.submitSignOutSuccess,
            payload: getResponseValue(payload)
          };
        })
      );
    })
  );
};
registry.addEpic('submitSignOutEpic', submitSignOutEpic);

export const submitSignOutSuccess = (state: IAccountState, _action: IAccountAction): IAccountState => {
  auth.logout();
  return state;
};

export const submitSignOutFailed = (state: IAccountState, _action: IAccountAction): IAccountState => {
  const notifications: INotification[] = [
    {
      id: 'sign-out-failure',
      createdDateTime: moment(),
      localizableMessage: {
        key: 'Could not sign out.',
        options: {}
      },
      severity: NotificationSeverity.error,
      type: NotificationType.toast
    }
  ];

  return {
    ...state,
    notifications: notificationsMerge(notifications, state.notifications, state.notificationsLimit)
  };
};

registry.add(AccountActions.submitSignOutSuccess, submitSignOutSuccess);
registry.add(AccountActions.submitSignOutFailed, submitSignOutFailed);
